module.exports = __webpack_public_path__ + "img/16_43.dd96ccb8.png";